$(function() {
    $('a[href="#"], a[href=""]').on('click', function(e){
        e.preventDefault();
    });


    // Bootstrap Tooltip & Popover defaults

    $('[data-toggle="tooltip"]').tooltip()
    $('[data-toggle="popover"]').popover()


    // Ajax button
    $('button.ajax').on('click',function(){
        if ($(this).hasClass('ajax-active')){
            return false;
        }
        else {
            $(this).addClass('ajax-active');
        }
    });

    // Ajax DIV
    $('.ajax-trigger').on('click', function(){
        var target = '#'+$(this).data('ajax-target');
        if ($(target).hasClass('ajax')){
            $(target).addClass('ajax-active');
        }
    });

    // Rotated Tables
    $('.table-header-rotated tbody td').hover(function(){
        // In function
        var target = this;
        var col = $(this).data('colid');
        var row = $(this).data('rowid');
        $('.table-header-rotated tbody tr[data-rowid="'+row+'"]').addClass('hover');
        $('.table-header-rotated tbody td[data-colid="'+col+'"]').addClass('hover');
        $('.table-header-rotated thead th[data-colid="'+col+'"]').addClass('hover');
    }, function(){
        // Out Function
        var target = this;
        var col = $(this).data('colid');
        var row = $(this).data('rowid');
        $('.table-header-rotated tbody tr[data-rowid="'+row+'"]').removeClass('hover');
        $('.table-header-rotated tbody td[data-colid="'+col+'"]').removeClass('hover');
        $('.table-header-rotated thead th[data-colid="'+col+'"]').removeClass('hover');
    });

    $('.longTextPreview').each(function(i){
        var thisDiv = this;
        if($(thisDiv)[0].scrollHeight > $(thisDiv).innerHeight()) {
            $(thisDiv).parent().mouseenter(function(){
                $(this).find('.longTextPreview').addClass('hoverized');
            }).mouseleave(function(){
                $(this).find('.longTextPreview').removeClass('hoverized');
            });
        }
        $("<i>").addClass('fa fa-chevron-down').attr('style', 'margin-right:5px;').prependTo(
            $(this).closest('.longTextPreviewWrapper').find('.longTextPreviewBtn')
        );
    });

    $(document).on('click', '.longTextPreviewBtn', function(){
        if ($(this).hasClass('closed')) {
            $(this)
                .removeClass('closed')
                .addClass('open')
                .html('Show Less')
                .prepend(
                    $("<i>").addClass('fa fa-chevron-up').attr('style', 'margin-right:5px;')
                );
        }
        else {
            $(this)
                .removeClass('open')
                .addClass('closed')
                .html('Show More')
                .prepend(
                    $("<i>").addClass('fa fa-chevron-down').attr('style', 'margin-right:5px;')
                );
        }
        $(this).closest('.longTextPreviewWrapper').find('.longTextPreview').toggleClass('view-all');
        return false;
    });
});
